
<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="my-3 mx-2">
            <div class="d-flex align-items-center my-1">
                <div class="mx-2 h3">Laws</div>
                <router-link to="/laws/add">
                    <button class="btn btn-sm border border-primary text-primary" v-if="permissions.ADD_CONTENT == 'Y'">
                        Add New Law
                    </button>
                </router-link>
            </div>
            <AllElements category_id="3" editLink="laws"></AllElements>
        </div>
    </div>
</template>
<script>
import AllElements from "@/components/ElementComponents/AllElements";

export default {
    created() {
        this.permissions = JSON.parse(localStorage.getItem("permissions"));
    },
    setup() { },
    components: {
        AllElements,
    },
    data() {
        return {
            permissions: {},
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Laws',
                    to: '/laws/all',
                }, {
                    text: 'All Laws',
                    href: '#'
                }
            ],
        }
    },
};
</script>